import * as React from "react";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { BackOfficeProviderBulkValuationReport } from "../../../../../../Wrap/Models/Models/BackOfficeIntegration/BackOfficeProviderBulkValuationReport";
import { ITableConfig, Table } from "../../../../../Shared/Table/Table";

interface IReportSearchResultTableProps {
    data: BackOfficeProviderBulkValuationReport[];
    isLoading: boolean;
}

export const ReportSearchResultTable = (props: IReportSearchResultTableProps) => {
    if (!props.data) {return null;}
    const PAGE_SIZE = 10;
    const [tableData, setTableData] = React.useState<BackOfficeProviderBulkValuationReport[]>([]);
    const [currentPage, setCurrentPage] = React.useState<number>(1);

    React.useEffect(() => {
        setCurrentPage(1);
        doPagination(1, props.data);
    }, [props.data]);

    const doPagination = (pageIndex, data) => {
        const startIndex = (pageIndex - 1) * PAGE_SIZE;
        const endIndex = pageIndex * PAGE_SIZE;
        setTableData(data.slice(startIndex, endIndex));
    };

    const col: ITableConfig[] = [
        {
            title: "Filename",
            key: "FileName",
            render: (data: string) => {
                return data;
            },
        },
        {
            title: "Date generated",
            key: "DateGenerated",
            render: (data: Date) => {
                return JsonDateParser.getFormatDateString(new Date(data), "dd MM yyyy", true);
            },
        },
        {
            title: "Download link",
            key: "FileNameEncryption",
            render: (data: string) => {
                return (
                    <a className={data === null ? "" : "hyperlink"}>
                        <span className="text" onClick={data === null ? () => {} : () => openDocument(data)}>
                            {data === null ? "Unmatched" : "Download"}
                        </span>
                    </a>
                );
            },
        },
    ];

    const openDocument = (fileNameEncryption: string) => {
        window.open(`/popups/loaddocstore.aspx?filename=${fileNameEncryption}&encrypt=yes`, "_blank");
    };

    return (
        <Table
            data={tableData}
            col={col}
            showEmptyMsg
            isLoading={props.isLoading}
            cssWrapper="mb-60"
            needPagination={{
                totalNumOfResult: props.data.length,
                onPaginationChange: (pageIndex, pageSize) => {
                    setCurrentPage(pageIndex);
                    doPagination(pageIndex, props.data);
                },
                pageSize: 10,
                currentPage: currentPage,
            }}
        />
    );
};
